/* eslint-disabled */

export default class CommissionExtend {

    customPremium = 0

    constructor(object?: any) {
        if (object) {
            this.customPremium = object.customPremium
        }
    }

    postConstruct() {
    }
}
